import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";
// custom CSS
import "./App.css";
import appData from "./app.json";

// apollo client
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "@apollo/react-hooks";

// authentication provider
import auth from "./providers/Auth.Provider"; // login staff token
import StartUp from "./Startup";
import { BrowserRouter as Router } from "react-router-dom";
import { initSocket } from "./sockette";
import REQUEST_ACCESS from "./providers/notificationProvider";
import "react-app-polyfill/stable";

// init socket
initSocket();

// system notification
REQUEST_ACCESS();

// // new instance of apollo client
export const client = new ApolloClient({
    uri: appData.baseUrl,
    request: (operation) => {
        const __token = auth.authProvider.GetToken();
        operation.setContext({
            headers: {
                authorization: __token ? `Bearer ${__token}` : "",
            },
        });
    },
    onError: ({ networkError }) => {
        if (networkError && networkError.message === "Failed to fetch") {
            networkError.message = "An error occurred! Check your internet connection and try again.";
        }
    },
});

ReactDOM.render(
    <ApolloProvider client={client}>
        <Router>
            <StartUp />
        </Router>
    </ApolloProvider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
